module.exports = __webpack_public_path__ + "img/reason12.0ca3189c.png";